import React, { useState } from 'react';
import { withStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { isEmpty } from 'lodash';

import NoBuyerFound from './NoBuyerFound';
import AddBuyerModal from './AddBuyerModal';
import BuyersSummary from './BuyersSummary';
import BuyersReview from './BuyersReview';

import styles from './styles';

function BuyerDetails({
  isEditable,
  application,
  buyers,
  documents,
  error,
  changeTransactionShareHandler,
  addBuyerHandler,
  deleteBuyerHandler,
  addRepresentativeHandler,
  deleteRepresentativeHandler,
  downloadDocumentHandler,
}) {
  if (isEditable === false && isEmpty(buyers)) return null;

  const locale = useSelector(state => state.language.locale);

  const [openAddBuyerModal, setOpenAddBuyerModal] = useState(false);
  const [selectedBuyer, setSelectedBuyer] = useState(null);
  const [isEditFlow, setIsEditFlow] = useState(false);

  const handleOpenAddBuyerModal = () => {
    setOpenAddBuyerModal(true);
  };

  const handleCloseAddBuyerModal = () => {
    setOpenAddBuyerModal(false);
    setSelectedBuyer(null);
  };

  const handleEditBuyer = buyerData => {
    setSelectedBuyer(buyerData);
    setIsEditFlow(true);
    handleOpenAddBuyerModal();
  };

  return (
    <>
      {isEditable === true && isEmpty(buyers) && <NoBuyerFound addBuyerHandler={handleOpenAddBuyerModal} />}
      {isEditable === true && !isEmpty(buyers) && (
        <BuyersSummary
          locale={locale}
          application={application}
          buyers={buyers}
          documents={documents}
          addBuyerHandler={handleOpenAddBuyerModal}
          editBuyerHandler={handleEditBuyer}
          deleteBuyerHandler={deleteBuyerHandler}
          addRepresentativeHandler={addRepresentativeHandler}
          deleteRepresentativeHandler={deleteRepresentativeHandler}
          buyerTransactionShareChangeHandler={changeTransactionShareHandler}
          downloadDocumentHandler={downloadDocumentHandler}
        />
      )}
      {isEditable === false && !isEmpty(buyers) && (
        <BuyersReview
          locale={locale}
          application={application}
          buyers={buyers}
          documents={documents}
          downloadDocumentHandler={downloadDocumentHandler}
        />
      )}
      {isEditable === true && openAddBuyerModal === true && (
        <AddBuyerModal
          locale={locale}
          openModal={openAddBuyerModal}
          buyer={selectedBuyer ?? {}}
          isEditFlow={isEditFlow}
          error={error}
          closeModalHandler={handleCloseAddBuyerModal}
          addBuyerHandler={addBuyerHandler}
        />
      )}
    </>
  );
}

BuyerDetails.propTypes = {
  isEditable: PropTypes.bool.isRequired,
  application: PropTypes.object.isRequired,
  buyers: PropTypes.array.isRequired,
  documents: PropTypes.array.isRequired,
  error: PropTypes.any.isRequired,
  changeTransactionShareHandler: PropTypes.func.isRequired,
  addBuyerHandler: PropTypes.func.isRequired,
  deleteBuyerHandler: PropTypes.func.isRequired,
  addRepresentativeHandler: PropTypes.func.isRequired,
  deleteRepresentativeHandler: PropTypes.func.isRequired,
  downloadDocumentHandler: PropTypes.func.isRequired,
};

export default withStyles(styles)(BuyerDetails);
